<template>
  <section>

    <div @click="edit" class="clickable clearfix documentItem request">
      <div class="logo">
        <div class="cover-small">
          <div class="cover-image-container">
            <div class="cover-outer-align">
              <div class="cover-inner-align">
                <i class="fal fa-file-alt fa-2x" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="information w-light">
        <h5>{{ details.document.name }} - Version {{ details.version.version }}</h5>
        <small v-bind:class="{ 'd-block d-lg-none': !showMinimal }">
          {{ details.team }}
          <br />
          {{ details.version.dclIdentity }}
          <span
            class="d-inline-block d-lg-none"
            v-if="!showMinimal"
          >- {{ $moment(details.version.publishedDate) | moment("YYYY-MM-DD HH:mm") }}</span>
        </small>
      </div>
      <div
        class="extrainformation w-light d-none d-lg-table-cell"
        v-if="!showMinimal"
      >{{ details.version.dclIdentity }}</div>
      <div class="information w-light d-none d-lg-table-cell" v-if="!showMinimal">{{ details.team }}</div>
      <div
        class="extrainformation w-light d-none d-lg-table-cell"
        v-if="!showMinimal"
      >{{ $moment(details.version.publishedDate) | moment("YYYY-MM-DD HH:mm") }}</div>
    </div>

    <b-modal v-model="modalEdit" size="lg" centered no-fade>
      <div slot="modal-header">{{$t('DOCUMENTS.REQUEST.TITLE')}}</div>
      <div class="p-4 text-center" v-if="modalEditLoading">
        <img src="img/loading.gif" />
        <h5 style="margin: 0; padding: 0;">{{$t('DOCUMENTS.REQUEST.PROCESSING')}}</h5>
      </div>
      <div class="p-4" v-if="modalEditLoading === false">

        <h3 class="mt-2 pl-2">{{ $t('DOCUMENTS.REQUEST.TO') }}</h3>
        
<hr />
        <dl>
          <dt>{{ $t('DOCUMENT.TITLE') }}</dt>
          <dd>
            <router-link
              :to="{ name: 'Document', params: { dclIdentity: details.version.dclIdentity}}"
            >{{ details.document.name }} {{ details.version.version }}</router-link>
          </dd>
          <dt>{{ $t('DCLIDENTITY') }}</dt>
          <dd>
            <router-link
              :to="{ name: 'Document', params: { dclIdentity: details.version.dclIdentity}}"
            >{{ details.version.dclIdentity }}</router-link>
          </dd>
          <dt>{{ $t('TEAM.TITLE') }}</dt>
          <dd>{{details.team}}</dd>
          <dt>{{ $t('PUBLISHED') }}</dt>
          <dd>{{ $moment(details.version.publishedDate) | moment("YYYY-MM-DD HH:mm") }}</dd>
        </dl>

<hr />
        <h3 class="mt-2 pl-2">{{ $t('DOCUMENTS.REQUEST.FROM') }}</h3>        

        <hr />

        <dl>
          <dt>{{ $t('DOCUMENT.TITLE') }}</dt>
          <dd>
            <router-link
              :to="{ name: 'Document', params: { dclIdentity: details.auditVersion.dclIdentity}}"
            >{{ details.auditDocument.name }} {{ details.auditVersion.version }}</router-link>
          </dd>
          <dt>{{ $t('DCLIDENTITY') }}</dt>
          <dd>
            <router-link
              :to="{ name: 'Document', params: { dclIdentity: details.auditVersion.dclIdentity}}"
            >{{ details.auditVersion.dclIdentity }}</router-link>
          </dd>
          <dt>{{ $t('TEAM.TITLE') }}</dt>
          <dd>{{details.auditTeam}}</dd>
          <dt>{{ $t('DOCUMENTS.REQUEST.PUBLISHED') }}</dt>
          <dd>{{ $moment(details.auditVersion.publishedDate) | moment("YYYY-MM-DD HH:mm") }}</dd>
        </dl>
      </div>

      <div slot="modal-footer" class="w-100">
        <div v-if="modalEditLoading === false">
          <b-btn @click="hideEditSection">{{ $t('CLOSE')}}</b-btn>

          <span v-if="administrator">
            <button
              class="btn btn-fill btn-primary float-right"
              id="popover-accept"
            >{{ $t('DOCUMENTS.REQUEST.APPROVE') }}</button>
            <button
              class="btn btn-fill btn-danger float-right"
              id="popover-deny"
            >{{ $t('DOCUMENTS.REQUEST.DENY') }}</button>
          </span>

            <b-popover
              target="popover-deny"
              :show.sync="popoverShowDeny"
              triggers="click"
              placement="auto"
            >
              <template v-slot:title>{{$t('CONFIRM')}}</template>
              <b-button @click="popoverShowDeny = false" size="sm" variant="secondary">{{$t('CLOSE')}}</b-button>
              <b-button @click="removeService" size="sm" variant="primary">{{$t('YES')}}</b-button>
            </b-popover>     
            <b-popover
              target="popover-accept"
              :show.sync="popoverShowAccept"
              triggers="click"
              placement="auto"
            >
              <template v-slot:title>{{$t('CONFIRM')}}</template>
              <b-button @click="popoverShowAccept = false" size="sm" variant="secondary">{{$t('CLOSE')}}</b-button>
              <b-button @click="approveRequest" size="sm" variant="primary">{{$t('YES')}}</b-button>
            </b-popover>        
        </div>
      </div>
    </b-modal>
  </section>
</template>
<script>
export default {
  props: ["item","small"],
  data() {
    return {
      showMinimal: this.small,
      popoverShowDeny: false,
      popoverShowAccept: false,
      modalEdit: false,
      modalEditLoading: false,
      approve: this.item.request.approved,
      details: this.item,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    edit() {
      this.modalEdit = true;
    },
    hideEditSection() {
      this.modalEdit = false;
      this.modalEditLoading = false;
    },
    approveRequest: function() {
      let self = this;
      this.modalUpdateLoading = true;
      this.$http
        .post(process.env.VUE_APP_BACKEND + `/document/request/update`, {
          requestId: this.details.request.id,
          approve: 1
        })
        .then(function(response) {
          self.details.request = response.data;
          self.$noty.info(
            self.$t("DOCUMENTS.REQUEST.SUCCESS.UPDATED_DOCUMENT")
          );
          self.hideEditSection();
        })
        .catch(function(error) {
          self.$noty.error(self.$t(error.response.data));
        });
    },
    denyRequest: function() {
      let self = this;
      this.modalUpdateLoading = true;
      this.$http
        .post(process.env.VUE_APP_BACKEND + `/document/request/update`, {
          requestId: this.details.request.id,
          approve: 0
        })
        .then(function(response) {
          self.details.request = response.data;
          self.$noty.info(
            self.$t("DOCUMENTS.REQUEST.SUCCESS.UPDATED_DOCUMENT")
          );
          self.hideEditSection();          
        })
        .catch(function(error) {
          self.$noty.error(self.$t(error.response.data));
        });
    }
  },
  computed: {
    administrator() {
      return this.user.team.id === this.details.auditDocument.teamId;
    }
  }
};
</script>
<style>
</style>